import { useAtomValue } from 'jotai';
import { atomActivatedI18n } from './atoms';
import { I18nProvider } from '@lingui/react';
import { ComponentProps } from 'react';

export default function WatershedI18nProvider({
  children,
}: Omit<ComponentProps<typeof I18nProvider>, 'i18n'>) {
  // This should suspend on loading messages
  const i18n = useAtomValue(atomActivatedI18n);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
